import THDStorageUtils, { LOCAL_STORAGE } from '@thd-olt-global/thd-storage-utils';
import { FALLBACK_USER_ID } from '../components/MagicApronAssistant/constants';

export const getMcvisID = () => {
  return window !== undefined
    ? window?.THDCustomer?.default?.mcvisID || FALLBACK_USER_ID : FALLBACK_USER_ID;
};

export const getSvocId = () => {
  return window !== undefined ? window?.THDCustomer?.default?.svocID || null : null;
};

export const getUserName = () => {
  return window !== undefined ? window?.THDCustomer?.default?.name || null : null;
};

export const getExperienceName = () => {
  if (typeof window !== 'undefined') {
    try {
      // eslint-disable-next-line no-restricted-globals
      return window.top?.experienceMetadata?.name;
    } catch {
      return 'magic-apron-assistant';
    }
  }

  return 'magic-apron-assistant';
};

export const getParentPagePath = () => {
  if (typeof window !== 'undefined') {
    try {
      // eslint-disable-next-line no-restricted-globals
      return new URL(parent.document.documentURI).pathname;
    } catch {
      return new URL(window.document.documentURI).pathname;
    }
  }

  return '';
};

export const getPageType = () => {
  const pathArray = getParentPagePath()?.split('/') || [];

  if (pathArray[1] === 'c') {
    return 'Content';
  }
  if (pathArray[1] === 'p') {
    return 'PIP';
  }
  if (pathArray[1] === 's' || pathArray[1] === 'b') {
    return 'PLP';
  }
  return 'Home';
};

export const getItemId = () => {
  if (getPageType() !== 'PIP') return null;

  return getParentPagePath().split('/').at(-1);
};

export const getRecentSearchTerms = () => {

  try {
    const history = THDStorageUtils.get(LOCAL_STORAGE, { key: 'header_search_history' });
    if (!history || history === 'undefined') return [];
    return JSON.parse(history).map((term) => {
      try {
        return decodeURIComponent(term.keyword);
      } catch {
        return term.keyword;
      }
    });

  } catch (error) {
    // eslint-disable-next-line no-console
    console.error({
      message: `Error occurred while accessing local storage - ${'header_search_history'}`,
      error
    });
    return [];
  }
};

export const getPageKey = () => {
  const splitPath = getParentPagePath().split('/');
  const pageType = getPageType();
  if (pageType === 'PIP' || pageType === 'Content') {
    return splitPath[2];
  }
  if (pageType === 'PLP') {
    return splitPath[3];
  }
  return 'Home';
};
